import { getUrl } from './base';

/**
 * Static paths (internal routing)
 * Used for: Next.js router, pathname checks, <Link />, UI logic
 */
export const staticPaths = {
  getBasePath: (): string => '/',
  getAboutPath: (): string => '/about',
  getContactPath: (): string => '/contact-us',
  getCareersPath: (): string => '/careers',
  getSolutionsPath: (): string => '/our-solutions',
  getBookDemoAllocatePath: (): string => '/our-solutions/book-demo-allocate',
  getTermsOfUsePath: (): string => '/terms-of-use',
  getPrivacyPolicyPath: (): string => '/privacy-policy',
  getSecurityPolicyPath: (): string => '/security-policy',
  getCompliancePath: (): string => '/compliance',
  getHipaaCompliancePath: (): string => '/compliance/hipaa',

  getStaticPagesList(): string[] {
    return [
      this.getAboutPath(),
      this.getCareersPath(),
      this.getSolutionsPath(),
      this.getBookDemoAllocatePath(),
      this.getContactPath(),
      this.getCompliancePath(),
      this.getHipaaCompliancePath(),
      this.getPrivacyPolicyPath(),
      this.getSecurityPolicyPath(),
      this.getTermsOfUsePath(),
    ];
  },
} as const;

/**
 * Static URLs (absolute)
 * Used for: cross-app navigation, external links
 */
const staticUrls = {
  getBaseUrl: (): string => getUrl(staticPaths.getBasePath()),
  getAboutUrl: (): string => getUrl(staticPaths.getAboutPath()),
  getContactUrl: (): string => getUrl(staticPaths.getContactPath()),
  getCareersUrl: (): string => getUrl(staticPaths.getCareersPath()),
  getSolutionsUrl: (): string => getUrl(staticPaths.getSolutionsPath()),
  getBookDemoAllocateUrl: (): string => getUrl(staticPaths.getBookDemoAllocatePath()),
  getTermsOfUseUrl: (): string => getUrl(staticPaths.getTermsOfUsePath()),
  getPrivacyPolicyUrl: (): string => getUrl(staticPaths.getPrivacyPolicyPath()),
  getSecurityPolicyUrl: (): string => getUrl(staticPaths.getSecurityPolicyPath()),
  getComplianceUrl: (): string => getUrl(staticPaths.getCompliancePath()),
  getHipaaComplianceUrl: (): string => getUrl(staticPaths.getHipaaCompliancePath()),

  getStaticPagesList(): string[] {
    return staticPaths
      .getStaticPagesList()
      .map((path) => getUrl(path));
  },
} as const;

export default staticUrls;
